export enum HeightUnits {
  FEET = 'feet',
  CM = 'cm',
}

export enum WeightUnits {
  LBS = 'lbs',
  KG = 'kg',
}
